"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Tooltip;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("../utils/styles");

var TooltipPrimitive = _interopRequireWildcard(require("@radix-ui/react-tooltip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Wrap a trigger element so that when it is hovered or focused a tooltip
 * appears.
 */
function Tooltip(_ref) {
  var _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'top' : _ref$placement,
      _ref$alignment = _ref.alignment,
      alignment = _ref$alignment === void 0 ? 'center' : _ref$alignment,
      _ref$coloring = _ref.coloring,
      coloring = _ref$coloring === void 0 ? 'light' : _ref$coloring,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 'small' : _ref$padding,
      _ref$textSize = _ref.textSize,
      textSize = _ref$textSize === void 0 ? 's' : _ref$textSize,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? 'medium' : _ref$maxWidth,
      content = _ref.content,
      children = _ref.children,
      ariaLabel = _ref.ariaLabel;

  var _getTheme = (0, _styles.getTheme)(coloring),
      background = _getTheme.background,
      borderColor = _getTheme.borderColor,
      color = _getTheme.color,
      fill = _getTheme.fill,
      shadowColor = _getTheme.shadowColor;

  var triggerRef = (0, _react.useRef)(null);
  var bodyClasses = (0, _classnames.default)("".concat(background, " ").concat(borderColor, " ").concat(color, " border round"), {
    'txt-s': textSize === 's',
    'txt-xs': textSize === 'xs',
    'px12 py6': padding === 'small',
    wmax120: maxWidth === 'small',
    wmax240: maxWidth === 'medium'
  });

  var getContent = function getContent() {
    if (typeof content === 'function') {
      return content();
    }

    return content;
  };

  var Trigger = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
    var child = _react.Children.only(children); // Following the instructions provided by Radix on handling disabled
    // button elements: Since disabled buttons don't fire events, you need to:
    // - Render the Trigger as `span`.


    if ( /*#__PURE__*/(0, _react.isValidElement)(child) && child.props.disabled) {
      child = /*#__PURE__*/_react.default.createElement("span", _extends({}, props, {
        ref: ref,
        role: "button",
        className: "inline-block",
        tabIndex: 0
      }), child);
    }

    return /*#__PURE__*/_react.default.createElement(TooltipPrimitive.Trigger, {
      ref: ref,
      asChild: true
    }, child);
  });
  return /*#__PURE__*/_react.default.createElement(TooltipPrimitive.Provider, null, /*#__PURE__*/_react.default.createElement(TooltipPrimitive.Root, {
    delayDuration: 150
  }, disabled ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children) : /*#__PURE__*/_react.default.createElement(Trigger, {
    ref: triggerRef
  }), /*#__PURE__*/_react.default.createElement(TooltipPrimitive.Portal, null, /*#__PURE__*/_react.default.createElement(TooltipPrimitive.Content, {
    "aria-label": ariaLabel,
    side: placement,
    align: alignment,
    sideOffset: 6,
    className: bodyClasses,
    style: {
      filter: "drop-shadow(0 0 4px ".concat(shadowColor, ")")
    }
  }, getContent(), /*#__PURE__*/_react.default.createElement(TooltipPrimitive.Arrow, {
    width: 12,
    height: 6,
    offset: 6,
    fill: fill
  })))));
}

Tooltip.propTypes = {
  /**
   * The trigger element.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.node]).isRequired,

  /**
   * The tooltip content. This can either be a string, valid JSX, or a function
   * returning either.
   */
  content: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.node]).isRequired,

  /**
   * Placement of the tooltip in relation to the trigger element.
   */
  placement: _propTypes.default.oneOf(['top', 'bottom', 'left', 'right']),

  /**
   * `'center'`, `'start'`, `'end'` Alignment of the tooltip's edge in relation to the trigger element.
   */
  alignment: _propTypes.default.oneOf(['center', 'start', 'end']),

  /**
   * If `true`, the tooltip will not appear.
   */
  disabled: _propTypes.default.bool,

  /**
   * `'light'`, `'dark'`, `'warning'`, or `'error'`.
   */
  coloring: _propTypes.default.oneOf(['light', 'dark', 'warning', 'error']),

  /**
   * `'xs'` (extra small), `'s'` (small), or `'none'` (no size class).
   */
  textSize: _propTypes.default.oneOf(['xs', 's', 'none']),

  /**
   * `'small'`, `'medium'`, or `'none'` (no `wmax*` class).
   */
  maxWidth: _propTypes.default.oneOf(['small', 'medium', 'none']),

  /**
   * `'small'` or `'none'`.
   */
  padding: _propTypes.default.oneOf(['small', 'none']),

  /**
   * Optionally provide a description of the tooltip content. By default,
   * screenreaders will announce the content inside the component.
   */
  ariaLabel: _propTypes.default.string
};